import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getActiveStudentsByEventIdOptions } from '~entities/events/api/get-enrolled-active-students-by-event-id';
import { baseAPI } from '~shared/api/base-api';

interface UpdateEventAttendanceDatesParams {
  studentId: string;
  eventId: string;
  selectedScheduleDates: string[];
}

interface UpdateEventAttendanceDatesResponse {
  success: boolean;
  selectedScheduleDates: string[];
}

export const updateEventAttendanceDatesAPI = async (
  params: UpdateEventAttendanceDatesParams,
) => {
  const response = await baseAPI.patch<UpdateEventAttendanceDatesResponse>(
    `/students/${params.studentId}/events/${params.eventId}/attendance-dates`,
    { selectedScheduleDates: params.selectedScheduleDates },
  );
  return response.data;
};

export const useUpdateEventAttendanceDates = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEventAttendanceDatesAPI,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: getActiveStudentsByEventIdOptions({
          eventId: variables.eventId,
        }).queryKey,
      });
    },
  });
};
